import { pgTable, uuid, text, integer, jsonb, timestamp, index } from "drizzle-orm/pg-core";

export const funnelEvents = pgTable(
  "funnel_events",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    sessionId: uuid("session_id").notNull(),
    storefrontSource: text("storefront_source").notNull().default("lv"),
    eventType: text("event_type").notNull().$type<"add_to_cart" | "payment_initiated">(),
    path: text("path"),
    valueCents: integer("value_cents"),
    metadata: jsonb("metadata"),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    sessionCreatedIdx: index("idx_funnel_events_session_created").on(t.sessionId, t.createdAt),
    typeCreatedIdx: index("idx_funnel_events_type_created").on(t.eventType, t.createdAt),
  }),
);

export type FunnelEvent = typeof funnelEvents.$inferSelect;
export type NewFunnelEvent = typeof funnelEvents.$inferInsert;
